import { useState } from 'react';
import { Check } from 'react-feather';

const CopyPasteString = (props: { value: string | null; fallbackText: string }) => {
  const { value, fallbackText } = props;
  //   const context = useGeneralContext();
  //   const { referralCode } = context;
  const [copied, setCopied] = useState(false);

  //   const referralUrl = referralCode ? `https://jumblejournal.org?ref=${referralCode}` : '';

  const handleCopyToClipboard = async () => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
    }
  };

  if (!value) {
    return <div className="tw-text-sm tw-text-neutral-500">{fallbackText}</div>;
  }

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-w-full lg:tw-w-[75%]">
      <div className="tw-flex tw-gap-2 tw-p-3 tw-bg-neutral-50 tw-border tw-border-neutral-200 tw-rounded-lg tw-w-full">
        <input
          type="text"
          value={value}
          readOnly
          className="tw-bg-transparent tw-border-none tw-outline-none tw-text-sm tw-text-neutral-700 tw-flex-1 tw-min-w-0"
        />
        <button
          onClick={handleCopyToClipboard}
          className="tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1 tw-bg-primary-100 tw-text-primary-700 tw-border tw-border-primary-200 tw-rounded hover:tw-bg-primary-200 tw-text-xs tw-font-medium tw-whitespace-nowrap"
        >
          {copied ? (
            <>
              <Check className="tw-w-3 tw-h-3 tw-shrink-0" />
              Copied
            </>
          ) : (
            'Copy'
          )}
        </button>
      </div>
    </div>
  );
};

export { CopyPasteString };
